package br.com.texeratx.boardgametimeapp.data.model.expansion

import kotlinx.serialization.Serializable

@Serializable
data class UpdateExpansionRequest(
    val name: String? = null,
    val gameId: Long? = null,
    val imageUrl: String? = null,
    val bggUrl: String? = null
)
